import apiHelpers from '@/utils/api'
import { AloDataPoolItem } from '@/models/alo/AloDataPoolItem'
import { AlrContainer } from '@/models/response/AlrContainer'
import {AxiosPromise} from 'axios'


export default {  
  getDataPool({usrId=null,keyFilter=null,useContains=false}={} as {usrId:null|number,keyFilter:string|null,useContains:boolean} ):AxiosPromise<AlrContainer<Array<AloDataPoolItem>>> {    
    return apiHelpers.apiCall({ 
        url: 'api/datapool', 
        method: 'GET', 
        params: {usrId,keyFilter,useContains},
        transformResponse: [function (data:string) {          
          return new AlrContainer<Array<AloDataPoolItem>>(JSON.parse(data),AloDataPoolItem.createAloDataPoolItemArray)      
        }]})
  },
  getMessageAccueil():AxiosPromise<AlrContainer<AloDataPoolItem>> {
    return  apiHelpers.apiCall({ 
      url: `api/datapool/messageAccueil`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<Array<AloDataPoolItem>>(JSON.parse(data),AloDataPoolItem.createAloDataPoolItemArray)
      }]
    })
  },  
  updateDataPool(dataPoolItem:AloDataPoolItem):AxiosPromise<AlrContainer<AloDataPoolItem>> {       
    //requete de mise à jour ou d'insertion
    const axiosConfig = {
      data :dataPoolItem,
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDataPoolItem>(JSON.parse(data),AloDataPoolItem.createAloDataPoolItem)      
      }]
    }
    return dataPoolItem.dtaId?
       apiHelpers.apiCall({ url: `api/datapool/${dataPoolItem.dtaId}`, method: 'PUT',  ...axiosConfig  })
      :apiHelpers.apiCall({ url: `api/datapool`, method: 'POST', ...axiosConfig  })    
  } 
}